/**
 * @module services/audit
 * @description Servicio HTTP para el módulo de auditoría médica
 */
import api from "./api";

export default {
  /** @param {Object} params - status, assignedTo, specialty, searchInput, offset, limit */
  get: (params) => api.get("/audit-cases", { params }).then((r) => r.data),
  /** @param {string} id */
  getById: (id) => api.get(`/audit-cases/${id}`).then((r) => r.data),
  /** @returns {Array} lista de auditores */
  getAuditors: () => api.get("/audit-cases/auditors").then((r) => r.data),
  /** @param {string} id @param {string} auditorId */
  assign: (id, auditorId) =>
    api.put(`/audit-cases/${id}/assign`, { auditorId }).then((r) => r.data),
  /** @param {string} id @param {string} specialtyId */
  setSpecialty: (id, specialtyId) =>
    api
      .put(`/audit-cases/${id}/specialty`, { specialtyId })
      .then((r) => r.data),
  /** @param {string} id @param {Object} dictum */
  addDictum: (id, dictum) =>
    api.post(`/audit-cases/${id}/dictum`, dictum).then((r) => r.data),
  /** @param {string} id @param {Object} interconsult */
  addInterconsult: (id, interconsult) =>
    api
      .post(`/audit-cases/${id}/interconsult`, interconsult)
      .then((r) => r.data),
};
